import { Button } from 'components/Button/Button'
import { IconPower } from 'components/icons/IconPower'
import { translate } from 'i18n/i18n'
import { useIntercom } from 'react-use-intercom'
import { apiFetch } from 'utils/apiFetch'
import { captureFrontendError } from 'utils/captureFrontendError'
import { ApiResponseError } from 'utils/errorCodes'
import { unauthenticateAppState } from 'utils/unauthenaticateAppState'

export const ButtonSignOut = () => {
  const intercom = useIntercom()

  return (
    <Button
      variant="link"
      css={{ color: 'white' }}
      onClick={async () => {
        try {
          await apiFetch({ url: '/logout', body: null })
        } catch (error) {
          // A 401 means the token is already invalid, which is what signing out is for
          if (!(error instanceof ApiResponseError && error.statusCode === 401)) captureFrontendError(error)
        }

        intercom.shutdown()

        await unauthenticateAppState()
      }}
      size="lg"
    >
      <div css={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconPower />
        <div css={{ marginLeft: 12 }}>{translate.phrases.banyanApp('Sign Out')}</div>
      </div>
    </Button>
  )
}
